import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { Fragment, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { CivilUnionVM } from 'mutation/view-models/civil-union';
import CivilUnionForm from 'mutation/components/shared/form-civil-union/resident';
import { CancelCivilUnionFormVM } from 'mutation/view-models/cancel-civil-union';
import { checkPersonCancelCivilUnion } from 'mutation/utils/transformer-cancel-civil-union';

const CivilUnion = (): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CancelCivilUnionFormVM>();

  const onFieldCivilUnionChange = useEventCallback(
    (key: keyof CivilUnionVM, value: CivilUnionVM[keyof CivilUnionVM]) => {
      formContext.setFieldValue('civilUnion', {
        ...(formContext.values.civilUnion || {}),
        [key]: value,
      });
    }
  );

  const onFieldCivilUnionChangeValues = useEventCallback((value: CivilUnionVM) => {
    formContext.setFieldValue('civilUnion', {
      ...(formContext.values.civilUnion || {}),
      ...value,
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-union-civil-content"
          id="panel-union-civil-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Unione civile</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CivilUnionForm
            values={formContext.values.civilUnion}
            onChange={onFieldCivilUnionChange}
            onChangeValues={onFieldCivilUnionChangeValues}
            errors={formContext.errors.civilUnion as FormikErrors<CivilUnionVM>}
            touched={formContext.touched.civilUnion as unknown as FormikTouched<CivilUnionVM>}
            disabled
            errorMessage="l'annullamento dell'unione civile"
            checkPerson={(person) => {
              return checkPersonCancelCivilUnion(person.statoCivile?.statoCivile);
            }}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

CivilUnion.displayName = 'Accordion Civil Union component';

export default CivilUnion;
